import { isUserLoggedIn } from "@/auth/utils";

export default [
    {
        name: "email-inbox",
        path: "/email-inbox/:chatId?",
        component: () => import(`@/views/modules/email-inbox/emailInbox.vue`),
        meta: {
            contentRenderer: "sidebar-left",
            contentClass: "chat-application",
            navActiveLink: "email-inbox",
            resource: "emailInbox",
            action: "read",
        },
        beforeEnter: isUserLoggedIn,
    },
];
